export default __webpack_public_path__ + "static/media/howtofindAgentsGif.6470b6aa.gif";